import { useEffect, useState } from "react"
import { useToaster } from "../../../contexts/Toaster"
import { useCharacters } from "../../../contexts/Characters"
import { capitalize } from "../../../utilities/helpers"
import Select from "../../forms/Select/Select"
import koalition from "../../../api/koalition"
import Input from "../../forms/Input/Input"
import { Roles as AppRoles } from "../../../utilities/constants"

const Roles = ({}) => {
    const toaster = useToaster()
    const characters = useCharacters()
    const [visibleCharacters, setVisibleCharacters] = useState([])
    const [rolesOptions, setRolesOptions] = useState([])
    const [filterKey, setFilterKey] = useState()
    const rolesOrder = ['admin', 'leader', 'player']

    const changeCharacterRole = (character, roleOption) => {
        koalition.put(`/characters/${character._id}`, { role: roleOption.value }).then((response) => {
            toaster.success(`${character.name} role set to ${roleOption.label}`)
        })
    }

    const onRoleChange = (roleOption, character) => {
        if (roleOption.value && character.role._id !== roleOption.value) changeCharacterRole(character, roleOption)
    }

    useEffect(() => {
        if (characters.$state.server) {
            const filteredCharacters = characters.$state.server.list.filter((character) => {
                return (!filterKey || character.name.toLowerCase().includes(filterKey.toLowerCase())) && (character.role.name !== AppRoles.developer)
            })
            filteredCharacters.sort((character1, character2) => rolesOrder.indexOf(character1.role.name) - rolesOrder.indexOf(character2.role.name))
            setVisibleCharacters(filteredCharacters)
        }
    }, [characters.$state.server, filterKey])

    useEffect(() => {
        koalition.get('/roles').then((response) => {
            setRolesOptions(response.data.sort((role1, role2) => rolesOrder.indexOf(role1.name) - rolesOrder.indexOf(role2.name)).map((role) => ({ value: role._id, label: capitalize(role.name) })))
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }, [])

    return (
        <div className="container-fluid">
            <div className="row mb-4">
                <div className="col-sm-6 col-xl-4">
                    <Input onChange={setFilterKey} placeholder="Filter" />
                </div>
            </div>
            
            <hr className="my-4" />

            {(visibleCharacters.length && rolesOptions.length) ? (
                <ul className="row">
                    {visibleCharacters.map((character) => (
                        <li className="col-sm-6 col-xl-4" key={character._id}>
                            <div className="card character flex-center-y justify-content-between mb-3">
                                <span>{character.name}</span>
                                <Select options={rolesOptions} defaultValue={character.role._id} onSelect={(roleOption) => onRoleChange(roleOption ,character)} />
                            </div>
                        </li>
                    ))}
                </ul>
            ) : (
                <h3 className="text-center">No character found</h3>
            )}
        </div>
    )
}

export default Roles